import React, { useState, useEffect } from 'react';
import { useThemes } from '@core/hooks';

const XTreeViewItem = ({ data }) => {
  const [updAfter, setUpdAfter] = useState(false);

  useEffect(() => {
    setUpdAfter(false);
  }, []);

  const { isDark } = useThemes();

  const showText = () => (
    <span className={`${updAfter ? 'xtreeviewitem__text' : ''}`}>
      {data.text}
    </span>
  );

  if (data.separator) {
    return <div className={`separator ${isDark ? 'separator--dark' : ''}`} />;
  }

  if (data.path) {
    return (
      <a
        href={`/#${data.path}`}
        title={data.tooltip || ''}
        className="xtreeviewitem"
      >
        {showText()}
      </a>
    );
  }

  return (
    <div className="xtreeviewitem" title={data.tooltip || ''}>
      {showText()}
    </div>
  );
};

export default XTreeViewItem;
